module.exports = __webpack_public_path__ + "img/pic_coinstore_x2value@3x.3c4723f7.png";